import { NameDto } from './NameDto'

export enum GroupReferenceType {
  WithdrawBulk = 2100,
  WithdrawAmountSplit = 1100,
}

export interface GroupReferenceDto {
  id: string
  name: string
  type: NameDto<number>
}
